
import { WDCarousel, WDCarouselItem } from '../carousel';
import WDPane from './wd-pane';

export default class WDPaneCarousel extends WDPane
{

  #carousel;
  #maxIndicators = 10;
  #indicatorOffset = 0;
  #prevBtn;
  #nextBtn;
  #config;

  constructor(cfg)
  {
    super(cfg).classList.add('wd-pane-carousel');
    this.#config = Object.assign({}, cfg);
  };

  connectedCallback()
  {
    super.connectedCallback();
  }

  get carousel() { return this.#carousel; };



  buildCarousel(cfg)
  {
    this.#carousel = new WDCarousel(cfg);
    this.#carousel.createSlideHandler = (data) => this.createSlide(data);
    this.body.append(this.#carousel);

    this.#carousel.on('items:added slide:end', () => {
      this.trigger('progress:updated');
      this.updateToolbar();
    });
  
    let filterCfg = null;

    //I can't decide on naming yet
    if (cfg?.filters) filterCfg = { filters: cfg.filters };
    else if (cfg?.filterConfig) filterCfg = cfg.filterConfig;
    else if (cfg?.filterbar) filterCfg = cfg.filterbar;     //sticking with "filterbar" for the future when I need to pass an advancedd config

    //but will leave filterConfig for compatibility
    if (filterCfg) this.#carousel.filters = this.addFilters(filterCfg);

    return this.#carousel;
  };

  reqCarousel(cfg)
  {
    return new Promise((resolve, reject) =>
    {
      //init the list
      this.buildCarousel(cfg);

      if (this.#carousel.fetch)
      {
        if (this.#carousel.filters)
        {
          //we have filters, wait until they are ready so we can serialize default filter
          //values to pass to the api
          this.#carousel.filters.on('filter:ready', () =>
          {
            this.#carousel.req().then(() => resolve(this.#carousel.model));
          });
        }
        else
        {
          this.#carousel.req().then(() => resolve(this.#carousel.model));
        }

      }
      else
      {
        resolve(this.#carousel.model);
      }
    });
  };

  createSlide(data)
  {
    return new WDCarouselItem(data);
  }

  updateToolbar()
  {
    this.updateProgress();
    this.updateNavigation();
  }

  updateProgress()
  {
    const left = this.toolbar.left;
    left.empty();

    const resultCount = this.carousel.model.length;
    const curIdx = this.#carousel.curItemIndex;

    // Create progress indicator in left toolbar
    const progressContainer = left.add({ tag: 'div' });
    progressContainer.style.display = 'flex';
    progressContainer.style.alignItems = 'center';
    progressContainer.style.gap = '8px';

    const progressBar = document.createElement('progress');
    progressBar.max = resultCount;
    progressBar.value = curIdx + 1;
    progressBar.style.width = '100px';
    progressContainer.appendChild(progressBar);

    const countLabel = document.createElement('span');
    countLabel.textContent = `${curIdx + 1} of ${resultCount}`;
    progressContainer.appendChild(countLabel);
  }

  updateNavigation()
  {
    const right = this.toolbar.right;
    right.empty();

    const resultCount = this.carousel.model.length;
    const curIdx = this.#carousel.curItemIndex;
    const maxIndicators = this.#maxIndicators;
    const pad = 5; // Minimum items to show on each side of current

    // Add navigation buttons to right toolbar
    const firstBtn = right.add({ label: 'First', fasIcon: 'angles-left' });
    firstBtn.on('click', () => this.carousel.view(0));
    firstBtn.disabled = (curIdx === 0);

    const backBtn = right.add({ label: 'Prev', fasIcon: 'chevron-left' });
    backBtn.on('click', () => this.carousel.prev());
    backBtn.disabled = (curIdx === 0);

    // If we have fewer items than max indicators, show all
    if (resultCount <= maxIndicators) {
      this.carousel.model.forEach((item, idx) => {
        const btn = right.add({ label: idx + 1 });
        btn.on('click', () => this.carousel.view(idx));
        if (idx === curIdx) {
          btn.classList.add('active');
        }
      });
    } else {
      // Calculate the window of indicators to show
      let startIdx, endIdx;
      
      // Try to center current item with padding on both sides
      const idealStart = Math.max(0, curIdx - pad);
      const idealEnd = Math.min(resultCount - 1, curIdx + pad);
      
      // If we can fit max indicators starting from ideal start
      if (idealEnd - idealStart + 1 <= maxIndicators) {
        startIdx = idealStart;
        endIdx = Math.min(resultCount - 1, startIdx + maxIndicators - 1);
      } else {
        // Need to fit within maxIndicators, prioritize current item being visible
        const halfMax = Math.floor(maxIndicators / 2);
        startIdx = Math.max(0, curIdx - halfMax);
        endIdx = Math.min(resultCount - 1, startIdx + maxIndicators - 1);
        
        // Adjust if we hit the end boundary
        if (endIdx === resultCount - 1 && endIdx - startIdx + 1 < maxIndicators) {
          startIdx = Math.max(0, endIdx - maxIndicators + 1);
        }
      }

      // Add indicators for the calculated range
      for (let idx = startIdx; idx <= endIdx; idx++) {
        const btn = right.add({ label: idx + 1 });
        btn.on('click', () => this.carousel.view(idx));
        if (idx === curIdx) {
          btn.classList.add('active');
        }
      }
    }

    // Add forward navigation buttons to right toolbar
    const nextBtn = right.add({ label: 'Next', suffix:'fa-solid fa-chevron-right' });
    nextBtn.on('click', () => this.carousel.next());
    nextBtn.disabled = (curIdx === resultCount - 1);

    const lastBtn = right.add({ label: 'Last', suffix: 'fa-solid fa-angles-right' });
    lastBtn.on('click', () => this.carousel.view(resultCount - 1));
    lastBtn.disabled = (curIdx === resultCount - 1);
  }

  updateIndicators()
  {
    // Deprecated method - use updateToolbar() instead
    this.updateToolbar();
  }

  fetchModel(wd) { return this.carousel.fetchModel(wd); };

};

customElements.define('wd-pane-carousel', WDPaneCarousel);
